/** The campaign's name, which customers see beside the discount. */
import { CAMPAIGN_NAME_MAX_LENGTH } from '@bonsai/shared';

import { fieldBoxStyle } from '../../../shared/date-time-range/picker-styles';
import { EditorFieldError } from '../../shared/editor-page/EditorFieldError';
import { EditorFormSection } from '../../shared/editor-page/EditorFormSection';

export interface CampaignNameSectionProps {
  value: string;
  error?: string;
  onChange: (name: string) => void;
}

export function CampaignNameSection({ value, error, onChange }: CampaignNameSectionProps) {
  return (
    <EditorFormSection
      title="Campaign name"
      titleId="campaign-name-title"
      hintId="campaign-name-hint"
      hint="Customers see this name next to the discount in the booking app."
    >
      <input
        aria-labelledby="campaign-name-title"
        aria-describedby={error ? 'campaign-name-error' : 'campaign-name-hint'}
        aria-invalid={Boolean(error)}
        value={value}
        maxLength={CAMPAIGN_NAME_MAX_LENGTH}
        placeholder="e.g. Fall Repotting Week"
        onChange={(e) => onChange(e.target.value)}
        style={{ ...fieldBoxStyle(false, Boolean(error)), width: '100%', fontSize: 14 }}
      />
      {error && <EditorFieldError id="campaign-name-error">{error}</EditorFieldError>}
    </EditorFormSection>
  );
}
